import { useCallback, useState } from "react";
import { useEffect } from "react";
import { Status } from "../../../common/constants";
import { useSpinner } from "../../../customHooks";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrganisationLicenses,
  selector as licensingApi,
} from "./licensingSlice";
import { ILicensingDetail } from "../../../common/types/mobileLicensingTypes";
import { ThunkDispatch } from "redux-thunk";

export const useLicensing = (orgId: string) => {
  const [show, setShow] = useState<boolean>(false);
  const organisationLicenses = useSelector(licensingApi);
  const organisationLicensingDetails: ILicensingDetail[] =
    organisationLicenses.licensingDetails;
  const dispatch: ThunkDispatch<any, undefined, any> = useDispatch();
  useSpinner(organisationLicenses.status);
  const [activeLicense, setActiveLicense] = useState(null);
  const [activeAction, setActiveAction] = useState(null);
  const handleClose = useCallback(() => {
    setShow(false);
  }, [setShow]);
  const handleShow = useCallback(() => {
    setShow(true);
    if (orgId) dispatch(getOrganisationLicenses(orgId));
  }, [orgId, dispatch]);
  const handleCloseNestedModal=()=>{
    setActiveAction(null);
    setActiveLicense(null);
  }
  return {
    show,
    handleClose,
    handleShow,
    activeLicense,
    setActiveAction,
    setActiveLicense,
    activeAction,
    organisationLicensingDetails,
    handleCloseNestedModal
  };
};
